export default {
    namespaced: true,
    state: {
        tokens: null,
        saveCard: false,
        tokenId: null
    },
    mutations: {
        setTokens(state, tokens) {
            state.tokens = tokens;
        },
        setSaveCard(state, save) {
            state.saveCard = save;
        },
        setTokenId(state, id) {
            state.tokenId = id;
        }
    },
    actions: {
        getPayuTokens(context) {
            return this.$axios.get('/tokens')
                .then(response => {
                    if(response.data.tokens) {
                        context.commit('setTokens', response.data.tokens);
                    }

                    return response;
                });
        },

        setSaveCard(context, param) {
            context.commit('setSaveCard', param);
        },

        setTokenId(context, param) {
            context.commit('setTokenId', param);
        },

        deleteToken({commit}, id) {
            return this.$axios.delete('/tokens/' + id)
                .then(response => {
                    if(response.data.tokens) {
                        commit('setTokens', response.data.tokens);
                    }

                    return response;
                });
        }

    },
    getters: {
        getTokens({tokens}) {
            return tokens;
        },
        getSaveCard({saveCard}) {
            return saveCard;
        },
        getTokenId({tokenId}) {
            return tokenId;
        }
    }
}
